import type {
    CreateSocketEventBaseParams,
    SocketEventBase,
    SocketEventType} from "@@/shared/socket-events/socket-event-base";
import {
    createSocketEventBase
} from "@@/shared/socket-events/socket-event-base";
import type { TicketSocketEventData } from "./ticket-socket-event-data";

type TicketSocketEventNamespace = "ticket";
type TicketSocketEventBaseType<SpecificType extends string = string> =
    SocketEventType<TicketSocketEventNamespace, SpecificType>;
type TicketSocketEventBase<
    SpecificType extends string = string,
    EventData extends Record<string, unknown> = Record<string, unknown>
> = SocketEventBase<
    TicketSocketEventNamespace,
    SpecificType,
    TicketSocketEventData<EventData>
>;

const createTicketSocketEventBase = <
    SpecificType extends string = string,
    EventData extends Record<string, unknown> = Record<string, unknown>
>(
    params: CreateSocketEventBaseParams<
        TicketSocketEventNamespace,
        SpecificType,
        TicketSocketEventData<EventData>
    >
) =>
    createSocketEventBase<
        TicketSocketEventNamespace,
        SpecificType,
        TicketSocketEventData<EventData>
    >(params);

export type { TicketSocketEventBase, TicketSocketEventBaseType };
export { createTicketSocketEventBase };
